var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      [
        _vm.purchase.actions.customer.contract === "create"
          ? [
              _c(
                "b-overlay",
                {
                  attrs: {
                    show: _vm.isDataSending,
                    opacity: "0.6",
                    rounded: "",
                    "spinner-small": "",
                    "spinner-variant": "primary",
                  },
                },
                [
                  _c("form-row-contract-upload", {
                    attrs: {
                      disabled: !_vm.$store.getters.getCanSign,
                      "label-cols-lg": 3,
                      v: _vm.$v.form.attachment,
                      "send-title": "Отправить контракт",
                      title: "Контракт",
                      "with-send": "",
                    },
                    on: { send: _vm.send },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "other",
                          fn: function () {
                            return [
                              _c(
                                "fl44-unknown-volume-send-decline-contract-button",
                                {
                                  staticClass: "ml-2",
                                  attrs: { "purchase-item": _vm.purchase },
                                  on: {
                                    refresh: function ($event) {
                                      return _vm.$emit(
                                        "refresh",
                                        _vm.$route.hash !== "" ? "" : null
                                      )
                                    },
                                  },
                                }
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      205003862
                    ),
                    model: {
                      value: _vm.form.attachment,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "attachment", $$v)
                      },
                      expression: "form.attachment",
                    },
                  }),
                ],
                1
              ),
              !_vm.$store.getters.getCanSign
                ? [
                    _vm.$store.getters.getLoginType === "cert"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                          },
                          [
                            _vm._v(
                              " Для действия требуется загрузить/заменить МЧД на странице: "
                            ),
                            _c(
                              "router-link",
                              {
                                staticClass: "green-link",
                                attrs: { to: { name: "CabinetUserProfile" } },
                              },
                              [_vm._v("Данные учетной записи")]
                            ),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticClass:
                              "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                          },
                          [
                            _vm._v(
                              "Отправка контракта возможна только при авторизации при помощи ЭЦП"
                            ),
                          ]
                        ),
                  ]
                : _vm._e(),
            ]
          : _vm.purchase.actions.customer.contract === "sign"
          ? _c("private-fl44-unknown-volume-contract-sign-form-customer", {
              attrs: { purchase: _vm.purchase },
              on: {
                refresh: function ($event) {
                  return _vm.$emit("refresh")
                },
              },
            })
          : _vm.purchase.actions.customer.contract === "reply"
          ? [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "10" } },
                    [
                      _c(
                        "text-header",
                        { attrs: { id: "atmo-disputes-resolution" } },
                        [_vm._v("Согласование разногласий по контракту")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-overlay",
                {
                  attrs: {
                    show: _vm.isDataSending,
                    opacity: "0.6",
                    rounded: "",
                    "spinner-small": "",
                    "spinner-variant": "primary",
                  },
                },
                [
                  _c("form-row-contract-upload", {
                    attrs: {
                      "label-cols-lg": 3,
                      v: _vm.$v.formDisagreement.contract,
                      title: "Новая редакция контракта",
                    },
                    model: {
                      value: _vm.formDisagreement.contract,
                      callback: function ($$v) {
                        _vm.$set(_vm.formDisagreement, "contract", $$v)
                      },
                      expression: "formDisagreement.contract",
                    },
                  }),
                  _c("form-row-contract-upload", {
                    attrs: {
                      "label-cols-lg": 3,
                      v: _vm.$v.formDisagreement.disagreement,
                      title: "Ответ на протокол разногласий",
                    },
                    model: {
                      value: _vm.formDisagreement.disagreement,
                      callback: function ($$v) {
                        _vm.$set(_vm.formDisagreement, "disagreement", $$v)
                      },
                      expression: "formDisagreement.disagreement",
                    },
                  }),
                  _c("form-row-edit-textarea", {
                    attrs: {
                      v: _vm.$v.formDisagreement.comment,
                      label: "Комментарий",
                    },
                    model: {
                      value: _vm.formDisagreement.comment,
                      callback: function ($$v) {
                        _vm.$set(_vm.formDisagreement, "comment", $$v)
                      },
                      expression: "formDisagreement.comment",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-overlay",
                {
                  attrs: {
                    show: _vm.isDataSending,
                    opacity: "0.6",
                    rounded: "",
                    "spinner-small": "",
                    "spinner-variant": "primary",
                  },
                },
                [
                  _c(
                    "b-btn",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        disabled:
                          !_vm.$store.getters.getCanSign ||
                          _vm.$v.formDisagreement.$invalid,
                        variant: "custom-green",
                      },
                      on: {
                        click: function ($event) {
                          _vm.showDisagreementModal = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        "Подписать и отправить ответ на протокол разногласий"
                      ),
                    ]
                  ),
                  _c("fl44-unknown-volume-sign-decline-contract-button", {
                    attrs: { "purchase-item": _vm.purchase },
                    on: {
                      refresh: function ($event) {
                        return _vm.$emit("refresh")
                      },
                    },
                  }),
                ],
                1
              ),
              !_vm.$store.getters.getCanSign
                ? [
                    _vm.$store.getters.getLoginType === "cert"
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                          },
                          [
                            _vm._v(
                              "Для действия требуется загрузить/заменить МЧД на странице: "
                            ),
                            _c(
                              "router-link",
                              {
                                staticClass: "green-link",
                                attrs: { to: { name: "CabinetUserProfile" } },
                              },
                              [_vm._v("Данные учетной записи")]
                            ),
                          ],
                          1
                        )
                      : _c(
                          "span",
                          {
                            staticClass:
                              "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                          },
                          [
                            _vm._v(
                              "Подписание возможно только при авторизации при помощи ЭЦП"
                            ),
                          ]
                        ),
                  ]
                : _vm._e(),
              _vm.formDisagreement.disagreement
                ? _c("sign-file-modal", {
                    attrs: {
                      attachment: _vm.formDisagreement.disagreement,
                      show: _vm.showDisagreementModal,
                      "is-sending": _vm.isDataSending,
                      title:
                        "Отправка подписанного ответа на протокол разногласий",
                    },
                    on: {
                      close: function ($event) {
                        _vm.showDisagreementModal = false
                      },
                      submit: _vm.storeSignedDisagreement,
                    },
                  })
                : _vm._e(),
            ]
          : _vm._e(),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }